import { api } from "..";

export function createShipmentRequest(data) {
  return api.post("/v1/shipment/create", data);
}

export function getShipmentsRequest({ params }) {
  return api.get(`/v1/shipment`, {
    params,
  });
}
